import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-db51eaec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout_view"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "layout_box"
}, null, -1));
import { reactive } from "vue";
import Layout from "./components";
import fixedRightButton from "@/components/fixedRightButton/index.vue";
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const {
      Navbar,
      Sidebar,
      AppMain,
      AppFooter
    } = Layout;
    const route = useRoute();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(fixedRightButton), _createVNode(_unref(Navbar)), _hoisted_2, _createVNode(_unref(AppMain)), _createVNode(_unref(AppFooter))]);
    };
  }
};